import { createFileRoute } from "@tanstack/react-router";
import { comingSoonPage } from "@/components/ComingSoon";
import { requireAuth } from "@/lib/auth-guard";

/**
 * Immediate Family Circle — mirrors iOS CircleScreen.
 * Phase B wires: GET /api/v1/families · PATCH /api/v1/families/{id}
 * (rename/avatar) · POST /api/v1/families/{id}/remove-member
 * ({userId, ownerDisposition, keepLink}) · POST /api/v1/families/{id}/leave
 * · GET /api/v1/invites/by-family/{id} · POST /api/v1/invites/mint
 * (intent=join_ifc) · POST /api/v1/invites/{id}/revoke.
 * Rules: invite + remove are owner-only; minors can't be removed (403);
 * invite cap 409 invite_cap_reached; seats cap 402 feature_gated.
 */
export const Route = createFileRoute("/circle")({
  loader: ({ context }) => requireAuth(context.queryClient),
  component: comingSoonPage(
    "Immediate Family Circle",
    "See who's in your circle, invite someone, and manage members — all from the web. We're building this surface now.",
  ),
});
